import * as api from './adapter';

export default {
  index: () => ({
    data: {
      data: [
        { id: '020b39f4', attributes: { name: 'wife' } },
        { id: '02db4ced', attributes: { name: 'mother' } },
        { id: '0ae61044', attributes: { name: 'father' } },
        { id: '16c5924a', attributes: { name: 'husband' } },
        { id: '25e6146e', attributes: { name: 'brother' } },
        { id: '263afa97', attributes: { name: 'sister' } },
        { id: '3341aee0', attributes: { name: 'daughter' } },
        { id: '3e60c8ee', attributes: { name: 'son' } },
        { id: '44a633c8', attributes: { name: 'aunt' } },
        { id: '483b30e1', attributes: { name: 'uncle' } },
        { id: '6f68a009', attributes: { name: 'bribe' } },
        { id: '7fd42918', attributes: { name: 'grandmothe' } },
        { id: '86f905ba', attributes: { name: 'niece' } },
        { id: '95d3e9d2', attributes: { name: 'ex-wife' } },
        { id: 'b6181eb9', attributes: { name: 'grandfathr' } },
      ],
      meta: { count: 19, page_count: 2 },
      links: {
        first: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=1&page%5Bsize%5D=15',
        next: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
        last: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
      },
    },
  }),
  /**
   * show
   * @param id
   * @return {Promise}
   */
  show: (id) => api.read(`/vendors/${id}`),
  /**
   * createCrewUser
   * @param attributes
   * @returns {Promise}
   */
  create: (attributes) => api.create({ type: 'vendors', attributes }),
  /**
   * updateCrewUser
   * @param id
   * @param attributes
   * @returns {Promise}
   */
  update: (id, attributes) => api.update({ id, type: 'vendors', attributes }),
  /**
   * deleteCrewUser
   * @returns {Promise<*>}
   */
  delete: (id) => api.destroy({ id, type: 'vendors' }),
};
